import React, {useEffect, useState} from 'react';
import {SearchResultItem} from './search-result-item';
import {ReactComponent as PageLeft} from '@assets/icons/page-left.svg';
import {ReactComponent as PageRight} from '@assets/icons/page-right.svg';
// @ts-ignore
import _ from 'lodash';

const RecommendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none">
      <rect width="6" height="6" fill="#C7812E" />
      <foreignObject x="1" y="1" width="8" height="8">
        <div
          // xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: 'blur(0.5px)',
            clipPath: 'url(#bgblur_0_7161_29083_clip_path)',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        dataFigma-bg-blur-radius="1"
        x="2"
        y="2"
        width="6"
        height="6"
        fill="#2EC7A2"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export function SearchRecommend({list}: {list: any[]}) {
  const [cdx, setCdx] = useState<number>(0);
  const [chunkList, setChunkList] = useState<any[][]>([]);
  useEffect(() => {
    const newList = _.chunk(list, 2);
    setChunkList(newList);
    setCdx(0);
  }, [list]);
  return list.length > 0 ? (
    <div className="bg-gradient-to-b from-white to-white/0 p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1">
          <RecommendIcon />
          <span className="text-t1 text-sm font-bold">Recommended For You</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() =>
              setCdx(prevState => (prevState > 0 ? prevState - 1 : 0))
            }
            className="w-7 h-7 shadow-[0px_1px_0px_rgba(148,157,183,0.5)] bg-gradient-to-b from-[#F2F6FF] to-[#DFE3ED] flex justify-center items-center rounded active:brightness-90">
            <PageLeft color="#9fa5ac" />
          </button>
          <button
            onClick={() =>
              setCdx(prevState =>
                prevState < chunkList.length - 1 ? prevState + 1 : prevState,
              )
            }
            className="w-7 h-7 shadow-[0px_1px_0px_rgba(148,157,183,0.5)] bg-gradient-to-b from-[#F2F6FF] to-[#DFE3ED] flex justify-center items-center rounded active:brightness-90">
            <PageRight color="#9fa5ac" />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 mt-[1.09375rem]">
        {chunkList[cdx]?.map(item => {
          return <SearchResultItem {...item} />;
        })}
      </div>
    </div>
  ) : null;
}
